module.exports = __webpack_public_path__ + "static/media/view5.72bcf18e.jpg";